import { useLocation } from 'react-router';
import { PageBlockLayout } from './page/PageBlockLayout';
import { getAppRouteByPath } from '../../../../constants/appRoutes';
import { PageHeaderWithConnectToSfButtons } from './page/PageHeaderWithConnectToSfButtons';

export const ConnectToSfPage = () => {
  const { pathname } = useLocation();
  const appRoute = getAppRouteByPath(pathname);
  const pageblockData = appRoute?.pageblockData;

  if (!pageblockData) {
    return null;
  }

  return (
    <PageBlockLayout
      header={<PageHeaderWithConnectToSfButtons {...pageblockData.headerData} />}
      pageblockData={pageblockData}
    />
  );
};
